// @flow
import { updateVisibleAirspaces } from 'actions/map';
import { computeTimeRangeSSC } from 'utils/datetime';

export const FILTERS_RESET_DATE_RANGE = 'filters/RESET_DATE_RANGE';
export const FILTERS_SET_DATE_RANGE = 'filters/SET_DATE_RANGE';
export const FILTERS_SET_TIME_RANGE = 'filters/SET_TIME_RANGE';
export const FILTERS_SET_AIRSPACE_USE_TYPE = 'filters/SET_AIRSPACE_USE_TYPE';
export const FILTERS_SET_ALTITUDE_RANGE = 'filters/SET_ALTITUDE_RANGE';
export const FILTERS_SET_IS_SRSS = 'filters/SET_IS_SRSS';

function updateTimeRangeForSRSS(getState) {
  const {
    filters: {
      dateRange: { min, max },
    },
  } = getState();
  const { minSunrise, maxSunset } = computeTimeRangeSSC(min, max);

  return setTimeRange({ min: minSunrise, max: maxSunset });
}

export function resetDateRange() {
  return (dispatch, getState) => {
    const {
      filters: { isSRSS },
    } = getState();

    dispatch({
      type: FILTERS_RESET_DATE_RANGE,
    });

    if (isSRSS) {
      dispatch(updateTimeRangeForSRSS(getState));
    } else {
      dispatch(updateVisibleAirspaces());
    }
  };
}

export function setDateRange(range) {
  return (dispatch, getState) => {
    const {
      filters: { isSRSS },
    } = getState();

    if (!range.max) {
      range.max = range.min;
    }

    dispatch({
      type: FILTERS_SET_DATE_RANGE,
      range,
    });

    if (isSRSS) {
      dispatch(updateTimeRangeForSRSS(getState));
    } else {
      dispatch(updateVisibleAirspaces());
    }
  };
}

export function setTimeRange(range) {
  return dispatch => {
    dispatch({
      type: FILTERS_SET_TIME_RANGE,
      range,
    });

    dispatch(updateVisibleAirspaces());
  };
}

export function setIsSRSS(isSRSS) {
  return (dispatch, getState) => {
    dispatch({
      type: FILTERS_SET_IS_SRSS,
      isSRSS,
    });

    if (isSRSS) {
      dispatch(updateTimeRangeForSRSS(getState));
    } else {
      dispatch(updateVisibleAirspaces());
    }
  };
}

export function setAirspaceUseType(airspaceUseType) {
  return dispatch => {
    dispatch({
      type: FILTERS_SET_AIRSPACE_USE_TYPE,
      airspaceUseType,
    });

    dispatch(updateVisibleAirspaces());
  };
}

export function setAltitudeRange(rangeBound, boundValue) {
  return dispatch => {
    dispatch({
      type: FILTERS_SET_ALTITUDE_RANGE,
      rangeBound,
      boundValue,
    });

    dispatch(updateVisibleAirspaces());
  };
}



// WEBPACK FOOTER //
// ./actions/filters.js